import * as React from 'react';
import { NavLink, Link } from "react-router-dom";
import { observer, inject } from "mobx-react";
import history from '../history';
import { Fab, Drawer, Button, Switch, RadioGroup, Radio, FormControl, FormControlLabel } from '@material-ui/core';
import InfiniteScroll from 'react-infinite-scroll-component';
import PeopleIcon from '@material-ui/icons/People';
import ListIcon from '@material-ui/icons/List';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';

// =====================================
// CONSTS
import { Messages } from '../../const/Messages';
import { CustomerSort } from '../../const/CustomerSort';

// =====================================
// STORES
import { ICustomerStore } from '../../store/CustomerStore';
import { ILoginStore } from '../../store/LoginStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';
import { SearchHeader } from '../Layout/SearchHeader';
import { Loader } from '../Layout/Loader';

@inject((allStores: any) => ({
    customerStore: allStores.store.customerStore as ICustomerStore,
    loginStore: allStores.store.loginStore as ILoginStore
}))

@observer
export default class Customers extends React.Component<{ customerStore?: ICustomerStore, loginStore?: ILoginStore }, any> {

    componentDidMount() {
        this.props.customerStore.init();
    }

    componentWillUnmount() {
        this.props.customerStore.reset();
    }

    redirectToNewCustomer = () => {
        history.push('./newcustomer');
    }

    render() {

        let headerComponent: any = null;
        if (!this.props.customerStore.isSearchHeaderVisible) {
            headerComponent =
                <Header
                    title="mKomercijalista"
                    isSignOutButtonVisible={true}
                    isSettingsButtonVisible={true}
                    isSearchButtonVisible={true}
                    handleDrawerOpen={this.props.customerStore.handleOpenDrawer}
                    searchAction={this.props.customerStore.showSearchHeaderForCustomers}
                    signOutAction={this.props.loginStore.onSignOut} />
        } else {
            headerComponent =
                <SearchHeader
                    samePageAction={this.props.customerStore.hideSearchHeader}
                    clearAction={this.props.customerStore.clearArticleSearch}
                    keyword={this.props.customerStore.keyword}
                    onHandleSearch={this.props.customerStore.handleCustomersSearch} />
        }


        if (this.props.customerStore.isLoading) {
            return <Loader />;
        }

        const removedDuplicatesCustomers = [...this.props.customerStore.customers];
        // const removedDuplicatesCustomers = this.props.customerStore.customers
        //     .filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)
        //     .filter(v => v.isInactive === false);

        return (
            <div>
                {headerComponent}

                <Fab color="primary" aria-label="add" className="add-btn" onClick={this.redirectToNewCustomer}>
                    <PersonAddIcon />
                </Fab>

                <div className="container customer-wrapper">
                    {!this.props.customerStore.isCustomersEmpty ?
                        <div>
                            {!this.props.customerStore.isSearchEmpty ?
                                <div>
                                    {/* <InfiniteScroll
                                    dataLength={removedDuplicatesCustomers.length}
                                    next={this.props.customerStore.getNextCustomers}
                                    hasMore={this.props.customerStore.hasMoreCustomersToLoad}
                                    endMessage={<div className="infinitescroll_msg">Svi kupci su učitani.</div>}
                                    loader={<div className="infinitescroll_msg">Učitavamo podatke...</div>}> */}
                                    {removedDuplicatesCustomers.map((customer, i) => {
                                        return <Link to={`/orders/${customer.id}`} key={i} className="customer-container">
                                            <div className="customer-row">
                                                <div className="image-container">
                                                    <img src="./assets/img/building.png" alt="building.png" />
                                                </div>
                                                <div className="main-heading">{customer.fullName}</div>
                                            </div>

                                            <div className="customer-row">
                                                <div className="image-container">
                                                    <img src="./assets/img/location.png" alt="location.png" />
                                                </div>
                                                <div className="sub-heading">{customer.companyAddress}</div>
                                            </div>

                                            {this.props.customerStore.isDebtInfoVisible ?
                                                <>
                                                    <div className="customer-row">
                                                        <div className="image-container">
                                                            <InfoIcon />
                                                        </div>
                                                        <div className="sub-heading">Ukupan dug: {customer.accountsReceivables.toLocaleString("sr", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} RSD</div>
                                                    </div>

                                                    <div className="customer-row">
                                                        <div className="image-container">
                                                            <InfoIcon />
                                                        </div>
                                                        <div className="sub-heading">Dug van valute: {customer.overdueAccountsReceivables.toLocaleString("sr", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} RSD</div>
                                                    </div>
                                                </> : null}
                                        </Link>
                                    })}
                                </div>
                                : <div className="no_data">{Messages.CUSTOMERS_SEARCH_EMPTY + this.props.customerStore.keyword}</div>}
                            {/* </InfiniteScroll> */}
                        </div>
                        : <div className="no_data">{Messages.NO_CUSTOMERS}</div>}
                </div>

                <div className="footer-icon-container">
                    <NavLink className="footer-icon col-6" to={"/customers"}>
                        <PeopleIcon />
                        <div>Klijenti</div>
                    </NavLink>
                    <NavLink className="footer-icon col-6" to={"/pricelist"}>
                        <ListIcon />
                        <div>Cenovnik</div>
                    </NavLink>
                </div>
                <Drawer
                    className="drawer-container"
                    anchor="left"
                    open={this.props.customerStore.isDrawerVisible}
                >
                    <div className="drawer-header">
                        <div className="drawer-title">Podešavanja</div>
                        <Button
                            startIcon={<CloseIcon />}
                            onClick={this.props.customerStore.handleCloseDrawer}
                            className="drawer-close"
                            color="primary">
                        </Button>
                    </div>

                    <div className="drawer-body">
                        <div className="drawer-form">
                            <label className="drawer-label">Prikaži ukupan dug/dug van valute kupaca</label>
                            <Switch
                                checked={this.props.customerStore.isDebtInfoVisible}
                                onChange={this.props.customerStore.handleChangeDebtVisibility}
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                        </div>

                        <div className="drawer-form">
                            <FormControl component="fieldset">
                                <label className="drawer-label">Sortiranje kupaca</label>
                                <RadioGroup row aria-label="orderLabel"
                                    value={this.props.customerStore.customerSorting}
                                    onChange={this.props.customerStore.handleChangeCustomerSorting}>
                                    <FormControlLabel value={CustomerSort.ALPHABETICALLY} control={<Radio />} label="Abecedno" />
                                    <FormControlLabel value={CustomerSort.DEBTAMOUNT} control={<Radio />} label="Visini dugovanja" />
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </div>
                </Drawer>
            </div>
        );
    }
}